import type {ServicesGlobal} from '~/payload-types'

export function useServicesMeta() {
  const sdk = usePayloadSdk()
  const route = useRoute()

  const fetch = async () => {
    const result = await sdk.findGlobal({
      slug: 'servicesGlobal',
      depth: 1,
      draft: !!route.query.preview,
    })
    return result as ServicesGlobal
  }

  return {fetch}
}
